import { render } from "./Rewards.vue?vue&type=template&id=320c41be"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__